import { useParams } from "react-router-dom";

const errorMessages: Record<string, { title: string; message: string }> = {
  "session-expired": {
    title: "Session Expired",
    message:
      "Your session has expired. Please return to your procurement system and start again.",
  },
  "session-invalid": {
    title: "Invalid Session",
    message:
      "Your session is invalid. Please return to your procurement system and start again.",
  },
  "submission-failed": {
    title: "Submission Failed",
    message:
      "We couldn't submit your order. Please try again or contact support.",
  },
  default: {
    title: "Something Went Wrong",
    message: "An unexpected error occurred. Please try again.",
  },
};

export function ErrorPage() {
  const { type } = useParams<{ type?: string }>();
  const error = errorMessages[type || ""] || errorMessages.default;

  return (
    <div className="container">
      <div className="card error-page">
        <h1>{error.title}</h1>
        <p>{error.message}</p>
      </div>
    </div>
  );
}
